<!-- 公告数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="formDataList" @tabs="(val) => { showTabs = val }"
                        @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="130px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo"
                                        size="mini" :show-message="false">
                                        <el-row ref="mainForm" v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.showField" :id="formOneValue.entityField"
                                                v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 开始时间 -->
                                                <df-date v-if="formOneValue.entityField == 'punStarttime'"
                                                    v-model="sendDataInfo.punStarttime"
                                                    :disabled="formOneValue.isChange == 0"></df-date>
                                                <!-- 结束时间 -->
                                                <df-date v-else-if="formOneValue.entityField == 'punValiduntil'"
                                                    v-model="sendDataInfo.punValiduntil"
                                                    :disabled="formOneValue.isChange == 0"></df-date>

                                                <!-- 状态 -->
                                                <el-select size="mini"
                                                    v-else-if="formOneValue.entityField == 'punSendstate'"
                                                    v-model="sendDataInfo.punSendstate">
                                                    <el-option v-for="item in toArray(formOneValue.formatterContent)"
                                                        :key="item.key" :value="item.key" :label="item.value"></el-option>
                                                </el-select>

                                                <!-- 公告内容 -->
                                                <!-- 公告内容--富文本 -->
                                                <quill-editor v-else-if="formOneValue.entityField == 'punContent'"
                                                    :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                                    v-model="sendDataInfo[formOneValue.entityField]" ref="myQuillEditor"
                                                    :options="editorOption" @blur="onEditorBlur($event)"
                                                    @focus="onEditorFocus($event)" @change="onEditorChange($event)"
                                                    class="myquillEditor"></quill-editor>

                                                <el-input v-else clearable
                                                    :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>

                                            </el-form-item>
                                        </el-row>
                                        <el-row ref="mainForm" v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'"
                                                v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'purmSdate'">{{
                                                    $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}</span>
                                                <span v-else-if="formOneValue.entityField == 'smId'">{{ sendDataInfo.smName
                                                }}</span>
                                                <span v-else-if="formOneValue.entityField == 'depId'">{{
                                                    sendDataInfo.depName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'isWms'">{{
                                                    sendDataInfo[formOneValue.entityField]
                                                    == 0 ? '否' : '新增' }}</span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>

                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType != 2" type="primary"
                            @click="initActionBox('sendDataInfo')">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    name: 'noticeAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            detaislDataInfo: {},
            selectedDataIndex: 0,
            sendDataInfo: {
                punContent: "", //	内容
                punStarttime: "", //	开始时间
                punTitle: "", //	标题
                punValiduntil: "", //	结束时间
                punSendstate: 1,    //状态
            },
            showTabs: '',
            formDataList: [],
            isLoaded: false,
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'font': [] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            // ['clean'], 
                            // ['link', 'image'] 
                        ],
                        handlers: {
                            'image': function (value) {
                                if (value) {
                                    document.querySelector('.edit-uploader input').click()
                                } else {
                                    this.quill.format('image', false);
                                }
                                // this.$refs.aUpload.click() //自定义图片上传回调 
                            }
                        }
                    },
                    syntax: {
                        highlight: text => hljs.highlightAuto(text).value
                    }
                }
            },
            quillUpdateImg: "",




        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 富文本编辑方法 
        onEditorReady(editor) { // 准备编辑器 
        },
        onEditorBlur() { }, // 失去焦点事件 
        onEditorFocus() { }, // 获得焦点事件 
        onEditorChange() { }, // 内容改变事件 
        beforeEditorUpload() {
            // 显示loading动画 
            this.quillUpdateImg = true
        },

        editorUploadSuccess(res, file) {
            // 获取富文本组件实例 
            let quill = this.$refs.myQuillEditor.quill
            // 如果上传成功 
            if (res.code === 0) {
                // 获取光标所在位置 
                let length = quill.getSelection().index;
                // 插入图片  res.info为服务器返回的图片地址 
                quill.insertEmbed(length, 'image', res.data.filepath)
                // 调整光标到最后 
                quill.setSelection(length + 1)
            } else {
                this.$message.error('图片插入失败')
            }
            // loading动画消失 
            this.quillUpdateImg = false
        },

        // 富文本图片上传失败 
        editorUploadError() {
            // loading动画消失 
            this.quillUpdateImg = false
            this.$message.error('图片插入失败')
        },


        toDetail(orderId) {
            this.$parent.$parent.$parent.toDetail(orderId)
            // this.$emit('toDetail',orderId)
        },

        tableRowClassName({
            row,
            rowIndex
        }) {
            row.index = rowIndex;
        },

        //确认新增
        sendDataAction(formName1) {
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    console.log('sendDataInfo', this.sendDataInfo)
                    this.sub()
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    return false;
                }
            })
        },
        async sub() {
            var responseData
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.publicNoticeAdd(this.sendDataInfo)
            } else {
                responseData = await this.$http.publicNoticeUpdate(this.sendDataInfo)
            }
            if (responseData.status == 200) {
                this.init()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$emit('drawerCancel')
                // this.dataActionBox.showStatus = false
                // this.$parent.getDataList()

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        //取消
        initActionBox(sendDataInfo) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? '新增' : '修改'
            this.$confirm('确定取消' + cancelTitle + '吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('drawerCancel')
                // this.$parent.getDataList()
                this.init()
                this.$refs[sendDataInfo].resetFields();
            }).catch(() => { });
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'punStarttime' || key == "punValiduntil") {
                    this.sendDataInfo[key] = this.$moment().valueOf()
                } else {
                    this.sendDataInfo[key] = ''
                }
                this.sendDataInfo.punSendstate = 1  //启用
            }
        },
        //父级传入
        openBox(cate, formData, oldData = '') {
            this.showTabs = formData[0].jciName
            this.formDataList = formData

            this.init()
            if (cate == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
            } else if (cate == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
            }
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true
        },
        //转换成数组
        toArray(str) {
            str && str.replace(/\\/g, '')
            try {
                var arr = JSON.parse(str);
                if (arr && Array.isArray(arr)) {
                    // console.log(arr)
                    return arr;
                } else {
                    return [];
                }
            } catch (e) {
                return [];
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            console.log(this.actionData);
            var params = this.actionData
            this.openBox(params.cate, params.formData, params.oldData)
            this.isLoaded = true
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.baseForm {
    height: 750px;
}

.myquillEditor {
    width: 600px !important;
    height: 400px;
}

::v-deep #punContent {
    width: 100% !important;
}
</style>
